import { CartLinesUpdateEvent, CartErrorEvent, StandardEvents } from '@shopify/events';
const { settlePajamaGifts, isPajamaLine, isPajamaGift } = await import(JSON.parse(document.querySelector('[data-pajama-cart-config]').textContent).module);

const escapeHTML = value => String(value ?? '').replace(/[&<>"']/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[char]));
const quickArtworkFrames = {"hello-kitty-pink-pajama-pants":{"width":1500,"height":1500,"x":391,"y":182,"visibleWidth":710,"visibleHeight":1192,"filename":"hello_kitty_pink_transparent.png"},"hello-kitty-white-pajama-pants":{"width":948,"height":1659,"x":33,"y":92,"visibleWidth":888,"visibleHeight":1514,"filename":"hello-kitty-white-pajama-pants-bundle.png"},"hello-kitty-coral-pink-pajama-pants":{"width":948,"height":1659,"x":33,"y":92,"visibleWidth":888,"visibleHeight":1514,"filename":"hello-kitty-coral-pink-pajama-pants-bundle.png"},"hello-kitty-black-pajama-pants":{"width":948,"height":1659,"x":33,"y":92,"visibleWidth":888,"visibleHeight":1514,"filename":"hello-kitty-black-pajama-pants-bundle.png"}};
const baseDiscount = quantity => quantity >= 3 ? 10 : quantity === 2 ? 5 : 0;
const tiers = [{d:0,g:0},{d:0,g:0},{d:5,g:0},{d:10,g:0},{d:10,g:1},{d:10,g:2},{d:15,g:2}];

class YumiPajamaBundle extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    this.controller = new AbortController();
    this.config = JSON.parse(this.querySelector('[data-config]').textContent);
    this.standalone = this.config.standalone === true;
    this.labels = this.config.labels;
    this.products = new Map();
    for (const item of this.config.products) this.remember(item);
    this.remember(this.config.product);
    this.minis = this.config.minis.filter(p => p.image && p.variants.some(v => v.available));
    this.current = this.products.get(String(this.config.product.id));
    this.baseCategory = this.config.category === 'auto' ? this.current?.category : this.config.category;
    const variant = this.current?.variants.find(v => v.id === String(this.config.product.variantId) && v.available) || this.current?.variants.find(v => v.available);
    this.selected = !this.standalone && variant ? [this.pick(this.current, variant, 'quick')] : [];
    this.quickOpen = -1;
    this.quickDrafts = new Map([[1,this.selected.slice()]]);
    this.quickPool = (this.config.quickProducts || this.config.products).map(raw=>{
      this.remember(raw);return this.products.get(String(raw.id));
    }).filter(p=>p&&p.category===this.baseCategory&&p.variants.some(v=>v.available));
    const classic=this.baseCategory==='Pants'?(this.config.quickHandles||[]).map(handle=>this.quickPool.find(p=>p.handle===handle)).filter(Boolean):[];
    this.quickPool = classic.length?classic:[this.current,...this.quickPool.filter(p=>p.id!==this.current?.id)].filter(Boolean).slice(0,4);
    this.gifts = [null, null];
    this.category = 'All';
    this.sizePicker = null;
    this.miniSlot = -1;
    this.pending = false;
    this.offer = 'base';
    this.cartContext = {items:[]};
    this.cartReady = false;
    this.nativeOriginals = new Map();
    this.hiddenControls = new Map();
    this.addUncertain = false;
    this.builder = this.querySelector('[data-builder]');
    this.modalNativeButton=this.querySelector('[data-modal-native] button');
    if(this.modalNativeButton)this.modalNativeButton.dataset.bagAdd='';
    this.scroller = this.querySelector('.yk-modal-content');
    const on = (node, name, handler, options = {}) => node.addEventListener(name, handler, {signal:this.controller.signal, ...options});
    on(document, 'click', event => this.nativeClick(event), {capture:true});
    on(document, 'submit', event => {
      if(event.target === this.nativeForm || this.matchingSticky().some(el=>el.contains(event.target))) {
        event.preventDefault();event.stopImmediatePropagation();this.addBag();
      }
    }, {capture:true});
    on(this, 'click', event => this.click(event));
    on(this, 'change', event => this.change(event));
    on(document, StandardEvents.cartLinesUpdate, event => {
      event.promise?.then(()=>{if(!this.pending)this.refreshCart().catch(()=>{});}).catch(()=>{});
    });
    on(this, 'keydown', event => {
      if(event.key==='Escape'&&this.quickOpen>=0&&!this.builder.open) {
        event.preventDefault();const index=this.quickOpen;this.quickOpen=-1;this.renderQuick();
        this.querySelector(`[data-quick-slot="${index}"]`)?.focus({preventScroll:true});
      }
      if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('.yk-clothing-model')) {
        event.preventDefault(); event.target.querySelector('[data-catalog-add]')?.click();
      }
    });
    on(this.scroller, 'scroll', () => this.fade(), {passive:true});
    on(this.builder, 'cancel', event => { if (this.miniSlot >= 0) {event.preventDefault(); this.closeMinis(true);} });
    on(this.builder, 'close', () => {
      this.unlockScroll();
      this.closeMinis();
      (this.returnFocus?.isConnected ? this.returnFocus : this.querySelector('[data-jump]'))?.focus({preventScroll:true});
    });
    this.observer = new ResizeObserver(() => this.fade());
    this.observer.observe(this.scroller);
    this.observer.observe(this.querySelector('[data-picker-slots]'));
    this.nativeComponent=this.standalone ? null : this.querySelector('product-form-component');
    this.nativeForm=this.nativeComponent?.querySelector('form[action*="/cart/add"]');
    this.nativeObserver=new MutationObserver(()=>this.syncNative());
    if(this.nativeComponent)this.nativeObserver.observe(this.nativeComponent,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled']});
    this.render();
    this.dataset.ready = 'true';
    this.loadCatalog();
    this.refreshCart().catch(()=>this.status(this.text('review_cart'),true));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.nativeObserver?.disconnect();
    this.nativeOriginals?.forEach((html,el)=>{el.innerHTML=html;el.removeAttribute('data-yumi-pajama-add');});
    this.hiddenControls?.forEach((hidden,el)=>{el.hidden=hidden;});
    this.builder?.close();
    this.unlockScroll();
    this.controller = null;
  }

  remember(raw) {
    if (!raw?.id || !raw.category || !raw.image) return;
    const product = {...raw, id:String(raw.id), variants:raw.variants.map(v => ({...v,id:String(v.id)}))};
    const existing=this.products.get(product.id);
    this.products.set(product.id, existing ? Object.assign(existing,product) : product);
  }

  text(key, values = {}) {
    let result = this.labels[key] || '';
    for (const [k,v] of Object.entries(values)) result = result.replaceAll('{{ '+k+' }}', String(v)).replaceAll('__'+k.toUpperCase()+'__',String(v));
    return result;
  }

  money(value) {
    return new Intl.NumberFormat(this.config.locale, {style:'currency',currency:this.config.currency}).format(value / 100);
  }

  pick(product, variant, origin = 'builder') {
    return {id:product.id,variantId:variant.id,size:variant.title,origin};
  }

  variant(item) { return this.products.get(item.id)?.variants.find(v => v.id === item.variantId); }

  total() {
    const n=this.selected.length, pooled=this.cartCount(this.offer)+n;
    const tier=this.offer==='base'?{d:baseDiscount(pooled),g:0}:tiers[Math.min(6,pooled)];
    const subtotal=this.selected.reduce((sum,item)=>sum+(this.variant(item)?.price || 0),0);
    const net=this.selected.reduce((sum,item)=>sum+Math.round((this.variant(item)?.price||0)*(100-tier.d)/100),0);
    return {n,pooled,tier,subtotal,net};
  }

  cartCount(offer) {
    return (this.cartContext?.items||[]).filter(i=>isPajamaLine(i)&&i.properties._yumi_pajama_offer===offer).reduce((sum,i)=>sum+i.quantity,0);
  }

  async refreshCart() {
    this.cartContext=await settlePajamaGifts();
    this.cartReady=true;
    const chosen=this.cartContext.items.filter(isPajamaGift).flatMap(line=>{
      const mini=this.minis.find(p=>p.variants.some(v=>String(v.id)===String(line.variant_id)));
      return mini?Array(line.quantity).fill(mini.id):[];
    }).slice(0,2);
    chosen.forEach((id,index)=>{if(!this.gifts[index])this.gifts[index]=id;});
    if(this.isConnected)this.render();
  }

  matchingSticky() {
    if(this.standalone)return [];
    const ids=new Set(this.current?.variants.map(v=>v.id));
    return [...document.querySelectorAll('yumi-sticky-add-to-cart')].filter(sticky=>{
      if(this.nativeForm&&sticky.mainForm===this.nativeForm)return true;
      try{return JSON.parse(sticky.querySelector('[data-satc-variants]')?.textContent||'[]').some(v=>ids.has(String(v.id)));}catch{return false;}
    });
  }

  nativeClick(event) {
    const button=event.target.closest('button');
    if(!button)return;
    const own=button===this.modalNativeButton||(this.nativeComponent?.contains(button)&&button.matches('add-to-cart-component button[type="submit"]'));
    const sticky=button.matches('[data-satc-button]')&&this.matchingSticky().some(el=>el.contains(button));
    if(!own&&!sticky)return;
    event.preventDefault();event.stopImmediatePropagation();
    if(!button.disabled)this.addBag();
  }

  syncNative() {
    const {n,tier,subtotal,net}=this.total();
    const disabled=!this.cartReady||this.pending||this.addUncertain||!n||this.selected.some(item=>!this.variant(item)?.available);
    const price=`${tier.d?`<s>${escapeHTML(this.money(subtotal))}</s>`:''}<strong>${escapeHTML(this.money(net))}</strong>`;
    this.nativeComponent?.querySelectorAll('quantity-selector-component,[ref="quantitySelectorWrapper"],.shopify-payment-button,[ref="acceleratedCheckoutButtonContainer"]').forEach(el=>{
      if(!this.hiddenControls.has(el))this.hiddenControls.set(el,el.hidden);
      if(!el.hidden)el.hidden=true;
    });
    this.nativeComponent?.querySelectorAll('add-to-cart-component button[type="submit"]').forEach(button=>{
      if(!this.nativeOriginals.has(button))this.nativeOriginals.set(button,button.innerHTML);
      button.setAttribute('data-yumi-pajama-add','');
      if(button.disabled!==disabled)button.disabled=disabled;
      button.setAttribute('aria-busy',String(this.pending));
      let content=button.querySelector('[data-pajama-native-content]');
      if(!content){
        const added=button.querySelector('.add-to-cart__added');
        [...button.childNodes].forEach(node=>{if(node!==added)node.remove();});
        content=document.createElement('span');content.dataset.pajamaNativeContent='';button.prepend(content);
      }
      const html=`<span>${escapeHTML(this.text(this.pending?'adding':'cart_label'))}</span><span aria-hidden="true">•</span><span class="add-to-cart-price">${price}</span>`;
      if(content.innerHTML!==html)content.innerHTML=html;
      if(this.modalNativeButton) {
        const modal=this.modalNativeButton,nativeStyle=getComputedStyle(button);
        const classes=button.className+' yk-native-modal-button';
        if(modal.className!==classes)modal.className=classes;
        for(const property of ['background-color','color','border-color','border-width','border-style','border-radius','font-family','font-size','font-weight','line-height','letter-spacing','text-transform','padding-top','padding-bottom','padding-left','padding-right','min-height']) {
          const value=nativeStyle.getPropertyValue(property);
          if(modal.style.getPropertyValue(property)!==value)modal.style.setProperty(property,value,property==='font-size'?'important':'');
        }
      }
    });
    this.matchingSticky().forEach(sticky=>{
      const button=sticky.querySelector('[data-satc-button]'),label=sticky.querySelector('[data-satc-label]'),amount=sticky.querySelector('[data-satc-price]');
      if(button){button.disabled=disabled;button.setAttribute('aria-busy',String(this.pending));}
      if(label)label.textContent=this.text(this.pending?'adding':'cart_label');
      if(amount&&amount.innerHTML!==price)amount.innerHTML=price;
    });
  }

  photo(product, className = '') {
    return `<img class="${className}" src="${escapeHTML(product.image)}" alt="${escapeHTML(product.name)}" width="240" height="270" loading="lazy">`;
  }

  setText(selector, text) {this.querySelectorAll(selector).forEach(el=>el.textContent=text);}

  status(message, cartLink = false) {
    this.querySelectorAll('[data-status], [data-pajama-status]').forEach(el=>{
      el.replaceChildren(document.createTextNode(message));
      if (cartLink) {const a=document.createElement('a');a.href=this.config.cartUrl;a.textContent=' '+this.text('cart_link');el.append(a);}
    });
  }

  async loadCatalog() {
    if (this.loading || !this.config.catalogUrl) return;
    this.loading=true;
    try {
      let next=this.config.catalogUrl;
      const visited=new Set();
      while (next && !visited.has(next)) {
        visited.add(next);
        const url=new URL(next,location.origin);
        if (url.origin!==location.origin) throw new Error('Invalid catalogue origin');
        url.searchParams.set('section_id','yumi-pajama-catalog');
        const response=await fetch(url,{signal:this.controller.signal,credentials:'same-origin'});
        if (!response.ok) throw new Error('Catalogue request failed');
        const doc=new DOMParser().parseFromString(await response.text(),'text/html');
        const node=doc.querySelector('[data-yumi-pajama-catalog]');
        if (!node) throw new Error('Catalogue payload missing');
        const page=JSON.parse(node.textContent);
        page.products.forEach(p=>this.remember(p));
        next=page.next;
      }
      this.catalogFailed=false;
      this.render();
    } catch(error) {
      if (error.name!=='AbortError') {
        this.catalogFailed=true;
        this.status(this.text('catalog_error'));
        this.renderCatalog();
      }
    } finally {this.loading=false;}
  }

  render() {
    const {n,pooled,tier,subtotal,net}=this.total();
    const progress=Math.min(6,pooled);
    const quick=this.selected.filter(item=>item.origin==='quick');
    this.renderQuick();
    this.setText('[data-top-note]',n>quick.length?this.text('combined_note',{count:n,percent:tier.d}):this.text('mix_note'));
    this.setText('[data-top-count]',this.text('selection',{count:n}));
    this.setText('[data-top-before], [data-cart-before]',this.money(subtotal));
    this.querySelectorAll('[data-top-before], [data-cart-before]').forEach(el=>el.hidden=!tier.d);
    this.setText('[data-top-total], [data-button-total], [data-cart-price]',this.money(net));
    this.setText('[data-add-label]',this.pending?this.text('adding'):this.text('add_label',{count:n}));
    this.setText('[data-builder] [data-add-label]',this.pending?this.text('adding'):this.text('cart_label'));
    this.setText('[data-builder-count]',this.text('count',{count:n}));
    this.querySelectorAll('[data-bag-add]').forEach(button=>{button.disabled=!this.cartReady||this.pending||this.addUncertain||!n||(button.closest('[data-builder]')&&pooled<2);button.setAttribute('aria-busy',String(this.pending));});
    this.setText('[data-launch-selection]',n?this.text('selection',{count:n})+' · '+this.money(net):'');
    this.setText('[data-reward-title]',pooled<2?this.text('start'):this.text(tier.g===2?'unlocked_two':tier.g===1?'unlocked_one':'unlocked',{percent:tier.d}));
    this.setText('[data-builder-count]',this.text('count',{count:progress}));
    this.setText('[data-next]',this.text('next_'+progress));
    this.querySelectorAll('.yk-progress span').forEach((el,index)=>el.classList.toggle('on',index<progress));
    this.querySelector('[data-ladder]').innerHTML=tiers.slice(1).map((tier,index)=>`<div class="yk-level${index+1===n?' active':''}">${escapeHTML(this.text(index?'pieces':'piece',{count:index+1}))}<b>${escapeHTML(tier.d?this.text('off',{percent:tier.d}):this.text('full_price'))}</b>${escapeHTML(this.text(tier.g===2?'gift_two':tier.g===1?'gift_one':'no_gift'))}</div>`).join('');
    if(this.offer==='byob')this.gifts=this.gifts.map((id,index)=>index<tier.g?id:null);
    this.renderCatalog();this.renderMinis();this.syncNative();
  }

  quickArtwork(product, surface) {
    const frame=quickArtworkFrames[product?.handle];
    const className=surface==='catalog'?'yk-quick-art':'yumi-bundle__artwork';
    if(!frame||!product.image.split('?')[0].endsWith('/'+frame.filename))return this.photo(product,className);
    // Normalize the visible garment in an SVG viewport; never edit the source image.
    // Catalogue reference: original Pink canvas. Offer reference: original Black canvas.
    const catalog=surface==='catalog'||surface==='selected',width=catalog?1500:948,height=catalog?1500:1659;
    const visibleHeight=catalog?1192:1514,scale=visibleHeight/frame.visibleHeight;
    const x=(width-frame.visibleWidth*scale)/2-frame.x*scale,y=(catalog?182:92)-frame.y*scale;
    return `<svg class="${className}" viewBox="0 0 ${width} ${height}" preserveAspectRatio="xMidYMid meet" role="img" aria-label="${escapeHTML(product.name)}"><image href="${escapeHTML(product.image)}" width="${frame.width}" height="${frame.height}" transform="translate(${x.toFixed(5)} ${y.toFixed(5)}) scale(${scale.toFixed(8)})"/></svg>`;
  }

  quickPicks(wanted) {
    const saved=this.quickDrafts.get(wanted);
    if(saved?.length===wanted)return saved;
    const companions=this.baseCategory==='Tops'
      ? ['hello-kitty-black-pajama-top','hello-kitty-white-pajama-top','hello-kitty-coral-pink-pajama-top','hello-kitty-soft-pink-pajama-top'].map(handle=>this.quickPool.find(p=>p.handle===handle)).filter(Boolean)
      : this.quickPool;
    const candidates=[this.current,...companions.filter(p=>p.id!==this.current?.id)].filter(Boolean);
    return Array.from({length:wanted},(_,index)=>{
      const product=(index===2&&this.baseCategory!=='Tops'?candidates.at(-1):candidates[index])||this.current,v=product?.variants.find(v=>v.available);
      return v?this.pick(product,v,'quick'):null;
    }).filter(Boolean);
  }

  saveQuick() {
    const quick=this.selected.filter(item=>item.origin==='quick');
    if(quick.length)this.quickDrafts.set(quick.length,quick.slice());
  }

  renderQuick() {
    if(this.standalone)return;
    const quick=this.selected.map((item,index)=>({item,index})).filter(({item})=>item.origin==='quick');
    const other=this.selected.length-quick.length;
    this.querySelectorAll('[data-quick]').forEach(button=>{
      const wanted=Number(button.dataset.quick),picks=this.quickPicks(wanted);
      button.setAttribute('aria-pressed',String(wanted===quick.length));
      button.disabled=wanted+other>6||this.pending||picks.length!==wanted;
      const discount=baseDiscount(this.cartCount('base')+wanted);
      const raw=picks.reduce((sum,item)=>sum+(this.variant(item)?.price||0),0);
      const net=picks.reduce((sum,item)=>sum+Math.round((this.variant(item)?.price||0)*(100-discount)/100),0);
      button.querySelector('[data-quick-price]').textContent=this.money(net);
      const before=button.querySelector('[data-quick-before]'),save=button.querySelector('[data-quick-save]');
      before.hidden=!discount;before.textContent=this.money(raw);
      save.hidden=!discount;save.textContent=this.text('save',{percent:discount});
      const order=wanted===1?[0]:wanted===2?[1,0]:[1,0,2];
      this.reconcileCatalog(button.querySelector('.yumi-bundle__offer-art'),order.map((slot,index)=>{const product=this.products.get(picks[slot]?.id);return {key:String(index),html:`<span class="yumi-bundle__offer-doll">${product?this.quickArtwork(product,'offer'):''}</span>`};}));
    });
    this.setText('[data-quick-count]',this.text('quick_selected',{count:quick.length,total:quick.length}));
    if(!quick.some(({index})=>index===this.quickOpen))this.quickOpen=-1;
    const arrow='<svg class="yumi-bundle__arrow" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 12 12 4M5 4h7v7" stroke="currentColor" stroke-width="1.2"/></svg>';
    this.reconcileCatalog(this.querySelector('[data-slots]'),quick.map(({item,index},slot)=>{
      const product=this.products.get(item.id),count=slot+1,expanded=this.quickOpen===index;
      const panelId=`quick-${this.config.id}-${index}`;
      return {key:item.renderKey ||= crypto.randomUUID(),html:`<div class="yk-quick-piece"><div class="yk-quick-row"><button type="button" class="yumi-bundle__slot is-filled" data-quick-slot="${index}" aria-expanded="${expanded}" aria-controls="${panelId}" ${this.pending?'disabled':''}><span class="yumi-bundle__slot-image">${this.quickArtwork(product,'selected')}</span><span class="yumi-bundle__slot-copy"><small>${escapeHTML(this.text('piece_label',{count}))}</small><strong>${escapeHTML(product.name)}</strong><span>${escapeHTML(product.quickDescription||product.description)}</span></span><span class="yumi-bundle__slot-action">${escapeHTML(this.text('quick_change'))} ${arrow}</span></button><label class="yk-quick-size"><select data-size="${index}" aria-label="${escapeHTML(this.text('size_label',{count}))}" ${this.pending?'disabled':''}>${product.variants.map(v=>`<option value="${v.id}" ${v.id===item.variantId?'selected':''} ${v.available?'':'disabled'}>${escapeHTML(v.title)}</option>`).join('')}</select></label></div><div id="${panelId}" class="yk-quick-panel${expanded?' is-open':''}" aria-hidden="${!expanded}" ${expanded?'':'inert'}><div class="yk-quick-panel-clip"><div class="yk-quick-options" role="group" aria-label="${escapeHTML(this.text('model_label',{count}))}">${this.quickPool.map(p=>`<button type="button" class="yk-quick-model" data-quick-model="${p.id}" data-quick-index="${index}" aria-pressed="${p.id===item.id}" ${this.pending?'disabled':''}>${this.quickArtwork(p,'catalog')}<strong>${escapeHTML(p.name)}</strong><span>${escapeHTML(p.quickDescription||p.description)}</span></button>`).join('')}</div></div></div></div>`};
    }));
  }

  patchCatalogNode(current,desired) {
    if(current.nodeType!==desired.nodeType||current.nodeName!==desired.nodeName) {
      current.replaceWith(desired);return desired;
    }
    if(current.nodeType===3) {
      if(current.nodeValue!==desired.nodeValue)current.nodeValue=desired.nodeValue;
      return current;
    }
    for(const attribute of [...current.attributes])if(attribute.name!=='data-render-key'&&!desired.hasAttribute(attribute.name))current.removeAttribute(attribute.name);
    for(const attribute of desired.attributes)if(current.getAttribute(attribute.name)!==attribute.value)current.setAttribute(attribute.name,attribute.value);
    const oldChildren=[...current.childNodes],newChildren=[...desired.childNodes];
    newChildren.forEach((child,index)=>oldChildren[index]?this.patchCatalogNode(oldChildren[index],child):current.append(child));
    oldChildren.slice(newChildren.length).forEach(child=>child.remove());
    return current;
  }

  reconcileCatalog(parent,entries) {
    const existing=new Map([...parent.children].map(node=>[node.dataset.renderKey,node]));
    const retained=new Set();let before=parent.firstElementChild;
    for(const {key,html} of entries) {
      const template=document.createElement('template');template.innerHTML=html;
      let node=existing.get(key);
      node=node?this.patchCatalogNode(node,template.content.firstElementChild):template.content.firstElementChild;
      node.dataset.renderKey=key;
      if(node!==before)parent.insertBefore(node,before);
      retained.add(node);before=node.nextElementSibling;
    }
    [...parent.children].forEach(node=>{if(!retained.has(node))node.remove();});
  }

  renderCatalog() {
    const {n,tier}=this.total();
    this.querySelectorAll('[data-catalog-category]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.catalogCategory===this.category)));
    const products=[...this.products.values()].filter(p=>this.category==='All'||p.category===this.category);
    const entries=products.map(p=>{
      const expanded=this.sizePicker===p.id&&n<6,count=this.selected.filter(i=>i.id===p.id).length;
      return {key:p.id,html:`<article class="yumi-bundle__model yk-clothing-model${expanded?' is-size-open':''}" tabindex="0" aria-label="${escapeHTML(this.text('choose_size',{product:p.name}))}"><span class="yumi-bundle__model-image">${this.photo(p,'yumi-bundle__artwork')}</span><div class="yk-size-action"><button type="button" class="yk-catalog-plus" data-catalog-add="${p.id}" ${n>=6||this.pending?'disabled':''} aria-expanded="${expanded}" aria-label="${escapeHTML(this.text('choose_size',{product:p.name}))}"><span aria-hidden="true">+</span></button><div class="yk-size-choices" role="group" aria-label="${escapeHTML(this.text('choose_size',{product:p.name}))}">${p.variants.map(v=>`<button type="button" data-pick-size="${v.id}" data-product="${p.id}" ${!v.available||n>=6||this.pending?'disabled':''} aria-label="${escapeHTML(this.text('add_variant',{product:p.name,size:v.title}))}">${escapeHTML(v.title)}</button>`).join('')}</div></div><strong>${escapeHTML(p.name)}</strong><span class="yk-model-price">${tier.d?`<del>${this.money(p.price)}</del> <b>${this.money(Math.round(p.price*(100-tier.d)/100))}</b>`:this.money(p.price)}</span>${count?`<small class="yk-selected-count">${escapeHTML(this.text('selected',{count}))}</small>`:''}</article>`};
    });
    if(!entries.length)entries.push({key:'empty',html:`<p class="yumi-bundle__empty">${escapeHTML(this.text('empty'))}</p>`});
    if(this.catalogFailed)entries.push({key:'retry',html:`<button type="button" data-retry>${escapeHTML(this.text('retry'))}</button>`});
    this.reconcileCatalog(this.querySelector('[data-picker-slots]'),entries);
    this.reconcileCatalog(this.querySelector('[data-selected-rows]'),this.selected.map((item,index)=>({key:item.renderKey ||= crypto.randomUUID(),html:`<button type="button" class="yumi-bundle__picked yk-selected-thumb" data-remove="${index}" ${this.pending?'disabled':''} aria-label="${escapeHTML(this.text('remove',{product:this.products.get(item.id).name,size:item.size}))}">${this.photo(this.products.get(item.id),'yumi-bundle__artwork')}<span aria-hidden="true" class="yk-thumb-remove">×</span><small>${escapeHTML(item.size)}</small></button>`})));
  }

  renderMinis() {
    const limit=this.total().tier.g;
    if(this.miniSlot>=limit)this.miniSlot=-1;
    const panelId='mini-panel-'+this.config.id;
    this.querySelector('[data-gifts]').hidden=false;
    this.querySelector('[data-gifts]').innerHTML=[0,1].map(index=>{
      const unlocked=index<limit,mini=this.minis.find(p=>p.id===this.gifts[index]);
      const label=mini?this.text('change_mini',{product:mini.name}):this.text(unlocked?'choose_mini':'locked_mini',{count:index+1,pieces:index+4});
      return `<button type="button" class="yk-mini-trigger${mini?' is-chosen':''}" data-mini-slot="${index}" ${unlocked&&!this.pending?'':'disabled'} aria-label="${escapeHTML(label)}" aria-expanded="${this.miniSlot===index}" aria-controls="${panelId}">${mini?this.photo(mini):`${unlocked?'<span aria-hidden="true">＋</span>':'<span class="yk-mini-lock" aria-hidden="true"></span>'}<span>${escapeHTML(this.text('mini',{count:index+1}))}</span><small>• ${escapeHTML(this.text('free'))}</small>`}</button>`;
    }).join('')+(this.miniSlot<0?'':`<section id="${panelId}" class="yk-mini-panel" aria-label="${escapeHTML(this.text('choose_mini',{count:this.miniSlot+1}))}"><header><strong>${escapeHTML(this.text('choose_your_mini'))}</strong><button type="button" data-mini-panel-close aria-label="${escapeHTML(this.text('close_mini'))}">×</button></header><div class="yk-mini-strip">${this.minis.map(p=>`<button type="button" class="yk-mini-option" data-mini-pick="${p.id}" aria-pressed="${this.gifts[this.miniSlot]===p.id}">${this.photo(p)}<strong>${escapeHTML(p.name)}</strong><span>${escapeHTML(p.description)}</span></button>`).join('')||`<p>${escapeHTML(this.text('empty'))}</p>`}</div></section>`);
  }

  closeMinis(focus=false) {const slot=this.miniSlot;this.miniSlot=-1;this.renderMinis();if(focus)this.querySelector(`[data-mini-slot="${slot}"]`)?.focus({preventScroll:true});}
  openMini(slot) {if(slot>=this.total().tier.g)return;this.miniSlot=this.miniSlot===slot?-1:slot;this.renderMinis();if(this.miniSlot>=0)this.querySelector('[data-mini-pick], [data-mini-panel-close]')?.focus({preventScroll:true});}

  openBuilder() {
    if(this.builder.open)return;
    this.offer='byob';this.render();
    this.scrollLocks=[document.documentElement,document.body].map(el=>({el,value:el.style.getPropertyValue('overflow'),priority:el.style.getPropertyPriority('overflow')}));
    this.scrollLocks.forEach(({el})=>el.style.setProperty('overflow','hidden'));
    this.returnFocus=document.activeElement;this.category='All';this.sizePicker=null;this.renderCatalog();this.builder.showModal();
    this.querySelector('[data-builder-close]').focus({preventScroll:true});
    this.fade();
    this.refreshCart().catch(()=>this.status(this.text('review_cart'),true));
  }

  unlockScroll() {
    this.scrollLocks?.forEach(({el,value,priority})=>value?el.style.setProperty('overflow',value,priority):el.style.removeProperty('overflow'));
    this.scrollLocks=null;
  }

  fade() {
    const el=this.scroller,distance=Math.max(0,el.scrollTop),remaining=Math.max(0,el.scrollHeight-el.clientHeight-distance);
    const top=Math.min(1,distance/40),bottom=Math.min(top,remaining/40);
    const alpha=(power,strength)=>'rgba(0,0,0,'+(1-power*strength).toFixed(3)+')';
    const mask=distance<1?'none':`linear-gradient(to bottom,${alpha(top,1)} 0%,${alpha(top,.84)} 12px,${alpha(top,.45)} 34px,#000 70px,#000 calc(100% - 70px),${alpha(bottom,.45)} calc(100% - 34px),${alpha(bottom,.84)} calc(100% - 12px),${alpha(bottom,1)} 100%)`;
    el.style.maskImage=mask;el.style.webkitMaskImage=mask;
  }

  click(event) {
    const target=event.target;
    if(this.miniSlot>=0&&!target.closest('[data-gifts]'))this.closeMinis();
    if(!target.closest('button,select')&&matchMedia('(max-width:749px), (hover:none)').matches){const card=target.closest('.yk-clothing-model');if(card){card.querySelector('[data-catalog-add]')?.click();return;}}
    if(target===this.builder){const r=this.builder.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.builder.close();return;}
    const button=target.closest('button');if(!button||button.disabled)return;
    const d=button.dataset;
    if('jump' in d){this.openBuilder();return;}
    if('builderClose' in d){this.builder.close();return;}
    if(this.pending)return;
    if('retry' in d){this.loadCatalog();return;}
    if('miniPanelClose' in d){this.closeMinis(true);return;}
    if('miniSlot' in d){this.openMini(Number(d.miniSlot));return;}
    if('miniPick' in d){if(this.miniSlot<0||!this.minis.some(p=>p.id===d.miniPick))return;const slot=this.miniSlot;this.gifts[slot]=d.miniPick;this.closeMinis();this.querySelector(`[data-mini-slot="${slot}"]`)?.focus({preventScroll:true});return;}
    if('catalogCategory' in d){this.category=d.catalogCategory;this.sizePicker=null;this.renderCatalog();this.scroller.scrollTop=0;this.fade();return;}
    if('catalogAdd' in d){if(this.selected.length>=6)return;this.sizePicker=d.catalogAdd;this.renderCatalog();this.querySelector(`[data-product="${this.sizePicker}"]:not(:disabled)`)?.focus({preventScroll:true});return;}
    if('pickSize' in d){const product=this.products.get(d.product),v=product?.variants.find(v=>v.id===d.pickSize&&v.available);if(!v||this.selected.length>=6)return;this.selected.push(this.pick(product,v));this.sizePicker=null;this.render();this.querySelector(`[data-catalog-add="${product.id}"]`)?.focus({preventScroll:true});return;}
    if('remove' in d){this.selected.splice(Number(d.remove),1);this.status('');this.render();this.querySelector(`[data-remove="${Math.min(Number(d.remove),this.selected.length-1)}"]`)?.focus({preventScroll:true});return;}
    if('quickSlot' in d){const index=Number(d.quickSlot);this.quickOpen=this.quickOpen===index?-1:index;this.renderQuick();return;}
    if('quickModel' in d){
      const index=Number(d.quickIndex),item=this.selected[index],p=this.quickPool.find(p=>p.id===d.quickModel);
      if(!item||item.origin!=='quick'||!p)return;
      const v=p.variants.find(v=>v.available&&v.title===item.size)||p.variants.find(v=>v.available);
      if(!v)return;
      this.selected[index]={...this.pick(p,v,'quick'),renderKey:item.renderKey};
      this.saveQuick();this.quickOpen=-1;this.render();
      this.querySelector(`[data-quick-slot="${index}"]`)?.focus({preventScroll:true});return;
    }
    if('quick' in d){
      const wanted=Number(d.quick),other=this.selected.filter(i=>i.origin!=='quick');
      if(wanted+other.length>6||!this.current)return;
      this.saveQuick();this.quickOpen=-1;this.offer=other.length?'byob':'base';
      this.selected=[...this.quickPicks(wanted),...other];this.render();return;
    }
    if('bagAdd' in d){const native=this.nativeComponent?.querySelector('add-to-cart-component button[type="submit"]');if(native)native.click();else this.addBag();}
  }

  change(event) {
    if(this.pending)return;
    const el=event.target;
    if('model' in el.dataset){const index=Number(el.dataset.model),p=this.products.get(el.value);const v=p?.variants.find(v=>v.title===this.selected[index].size&&v.available)||p?.variants.find(v=>v.available);if(v)this.selected[index]=this.pick(p,v,'quick');}
    if('size' in el.dataset){const index=Number(el.dataset.size),item=this.selected[index],p=this.products.get(item.id),v=p.variants.find(v=>v.id===el.value&&v.available);if(v){this.selected[index]={...this.pick(p,v,item.origin),renderKey:item.renderKey};this.saveQuick();}}
    this.render();
  }

  async addBag() {
    if(this.pending||this.preparing||this.addUncertain||!this.selected.length)return;
    this.preparing=true;
    try { await this.refreshCart(); }
    catch {this.status(this.text('review_cart'),true);return;}
    finally {this.preparing=false;}
    const {tier}=this.total(),missing=this.gifts.slice(0,tier.g).findIndex(id=>!id);
    if(missing>=0){this.openBuilder();this.status(this.text('choose_gifts'));this.openMini(missing);return;}
    if(!this.config.commerceReady){this.status(this.text('preview_only'));return;}
    if(this.selected.some(item=>!this.variant(item)?.available)){this.status(this.text('unavailable'));return;}
    const bundleId=crypto.randomUUID(),map=new Map();
    for(const item of this.selected)map.set(item.variantId,(map.get(item.variantId)||0)+1);
    const items=[...map].map(([id,quantity])=>({id:Number(id),quantity,properties:{_yumi_pajama_bundle:bundleId,_yumi_pajama_offer:this.offer}}));
    const desiredGifts=new Map(),giftUpdates={};
    for(const id of this.gifts.slice(0,tier.g)){
      const mini=this.minis.find(p=>p.id===id),v=mini?.variants.find(v=>v.available);
      if(!v){this.status(this.text('unavailable'));return;}
      desiredGifts.set(String(v.id),(desiredGifts.get(String(v.id))||0)+1);
    }
    if(this.offer==='byob') {
      for(const line of this.cartContext.items.filter(isPajamaGift)) {
        const wanted=desiredGifts.get(String(line.variant_id))||0,keep=Math.min(wanted,line.quantity);
        desiredGifts.set(String(line.variant_id),wanted-keep);
        if(keep!==line.quantity)giftUpdates[line.key]=keep;
      }
      for(const [id,quantity] of desiredGifts)if(quantity)items.push({id:Number(id),quantity,properties:{_yumi_pajama_bundle:bundleId,_yumi_pajama_gift:'1'}});
    }
    const sectionIds=[...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(el=>el.dataset.sectionId))].slice(0,5);
    const deferred=CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(()=>{});
    this.pending=true;this.status('');this.render();
    this.dispatchEvent(new CartLinesUpdateEvent({action:'add',context:'product',lines:items.map(i=>({merchandiseId:String(i.id),quantity:i.quantity})),promise:deferred.promise}));
    let posted=false;
    try {
      const response=await fetch(this.config.root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items,sections:sectionIds.join(','),sections_url:location.pathname+location.search})});
      const result=await response.json();
      if(!response.ok||result.status)throw new Error(typeof result.description==='string'?result.description:this.text('add_error'));
      posted=true;
      if(Object.keys(giftUpdates).length) {
        const update=await fetch(this.config.root+'cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json'},body:JSON.stringify({updates:giftUpdates,sections:sectionIds.join(','),sections_url:location.pathname})});
        if(!update.ok)throw new Error(this.text('review_cart'));
        result.sections=(await update.json()).sections;
      }
      const cartResponse=await fetch(this.config.root+'cart.js',{credentials:'same-origin',cache:'no-store'});
      if(!cartResponse.ok)throw new Error(this.text('review_cart'));
      const cart=await cartResponse.json();
      this.cartContext=cart;
      deferred.resolve({cart:CartLinesUpdateEvent.createCartFromAjaxResponse(cart),detail:{items:cart.items,sections:result.sections,source:'yumi-pajama-bundle',sourceId:this.id,productId:String(this.config.product.id),didError:false}});
      this.builder.close();this.selected=[];this.gifts=[null,null];this.status(this.text('success'));
    } catch(error) {
      this.addUncertain=true;
      deferred.reject(error);
      this.dispatchEvent(new CartErrorEvent({error:error.message,code:'SERVICE_UNAVAILABLE',detail:{source:'yumi-pajama-bundle'}}));
      this.status(posted?this.text('review_cart'):this.text('add_error'),true);
    } finally {this.pending=false;if(this.isConnected)this.render();}
  }
}

if(!customElements.get('yumi-pajama-bundle'))customElements.define('yumi-pajama-bundle',YumiPajamaBundle);
